export default "__VITE_ASSET__Dyhc7UoC__"